'use client';
export { SerialCodeFormText as default } from '@monorepo/common';
